export default __webpack_public_path__ + "static/media/et.6d34e426.svg";